export const prefixFormName = (formName, propName) => {
  if (formName) return `${formName}.${propName}`;
  return propName;
};
